<script setup>
defineProps({
  title: { type: String, required: true },
  text:  { type: String, required: true },
  icon:  { type: String, required: true } // 'report' | 'steps' | 'lock'
});
</script>

<template>
  <article class="feature card">
    <span class="feature-ic" aria-hidden="true">
      <svg v-if="icon==='report'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
        <path d="M6 3h9l3 3v15H6z" stroke-linejoin="round" />
        <path d="M9 12h6M9 16h6M9 8h3" stroke-linecap="round" />
      </svg>
      <svg v-else-if="icon==='steps'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
        <path d="M4 18h5v-4h5v-4h6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <svg v-else-if="icon==='lock'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8 11V8a4 4 0 118 0v3" />
      </svg>
    </span>
    <div class="feature-body">
      <h3>{{ title }}</h3>
      <p>{{ text }}</p>
    </div>
  </article>
</template>

<style scoped>
.feature {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
  align-items: start;
}
.feature-ic {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: color-mix(in srgb, var(--brand) 12%, var(--surface));
  color: var(--brand);
}
.feature-body h3 {
  margin: 2px 0 4px;
  font-size: 18px;
}
.feature-body p {
  margin: 0;
  font-size: 15px;
}
</style>
